export const containerStyles = {
  components: {
    Container: {
      baseStyle: {
        maxW: {
          sm: "95%",
          "2xl": "94em",
        },
      },
    },
  },
};
